import { Form, Input, Select } from "antd";
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import ExpertDataContext from "../../../../../context/expertDataContext";
import { getStaticExpertFields } from "../../../../../service/api";
import { useQuery } from "@tanstack/react-query";

function NameModal({ size, modalData }) {
  const { expertDataAction } = useContext(ExpertDataContext);
  const [academicFieldOptions, setAcademicFieldOptions] = useState();
  const [academicDegreeOptions, setAcademicDegreeOptions] = useState();
  const [workPlaceOptions, setWorkPlaceOptions] = useState();
  const [workPlaceId, setWorkPlaceId] = useState(
    modalData?.workplaceOrganizationTypeId
  );
  const [workPlacePositionOptions, setWorkPlacePositionOptions] = useState([
    {},
  ]);

  //get expert static fields
  const staticExpertFieldsQuery = useQuery(
    ["staticsExpertFields"],
    getStaticExpertFields
  );

  var pos;
  //set field and degree options from statics when staticExpertFieldsQuery done
  useEffect(() => {
    if (staticExpertFieldsQuery?.data) {
      setAcademicFieldOptions(
        staticExpertFieldsQuery?.data?.ACADEMIC_FIELDS?.map((item) => {
          return { label: item?.name, value: item?.id };
        })
      );
      setAcademicDegreeOptions(
        staticExpertFieldsQuery?.data?.ACADEMIC_DEGREE?.map((item) => {
          return { label: item?.name, value: item?.id };
        })
      );
      setWorkPlaceOptions(
        staticExpertFieldsQuery?.data?.WORKPLACE_ORGANIZATIONS?.map((item) => {
          return { label: item?.name, value: item?.id };
        })
      );

      pos =
        staticExpertFieldsQuery?.data?.WORKPLACE_ORGANIZATIONS_POSITIONS?.filter(
          (item) => item?.workplaceOrganizationTypeIds?.includes(workPlaceId)
        );

      setWorkPlacePositionOptions(
        pos?.map((item) => {
          return { label: item?.name, value: item?.id };
        })
      );

    }
  }, [staticExpertFieldsQuery?.data, workPlaceId]);

  const handleChange = (e) => {
    expertDataAction(e?.target?.name, e?.target?.value);
  };
  const handelSelectChange = (name, value) => {
    expertDataAction(name, value);
  };

  return (
    <Form layout="vertical">
      <div className="flex flex-row max-lg:flex-col justify-evenly ">
        <Form.Item label="نام:">
          <Input
            onChange={handleChange}
            name="firstName"
            defaultValue={modalData?.firstName}
            className="rounded-xl  bg-[#F6F6F6] "
          />
        </Form.Item>

        <Form.Item label="نام خانوادگی:">
          <Input
            name="lastName"
            onChange={handleChange}
            defaultValue={modalData?.lastName}
            className="rounded-xl  bg-[#F6F6F6]"
          />
        </Form.Item>
      </div>
      <div className="flex flex-row max-lg:flex-col justify-evenly">
        <Form.Item label="گرایش تحصیلی:">
          <Input
            name="academicOrientation"
            onChange={handleChange}
            defaultValue={modalData?.academicOrientation}
            className="rounded-xl  bg-[#F6F6F6] "
          />
        </Form.Item>
        <Form.Item label="دانشگاه:">
          <Input
            onChange={handleChange}
            name="university"
            defaultValue={modalData?.university}
            className="rounded-xl  bg-[#F6F6F6]"
          />
        </Form.Item>
      </div>
      <div className="flex flex-row max-lg:flex-col justify-evenly">
        <Form.Item label="رشته تحصیلی">
          <Select
            onChange={(e) => handelSelectChange("academicFieldId", e)}
            style={{ width: size }}
            placeholder="انتخاب کنید"
            defaultValue={modalData?.academicField?.name}
            options={academicFieldOptions}
            showSearch={false}
          />
        </Form.Item>
        <Form.Item label="مدرک تحصیلی">
          <Select
            onChange={(e) => handelSelectChange("academicDegreeId", e)}
            options={academicDegreeOptions}
            style={{ width: size }}
            placeholder="انتخاب کنید"
            defaultValue={modalData?.academicDegree?.name}
            showSearch={false}
          />
        </Form.Item>
      </div>
      <div className="flex flex-row max-lg:flex-col justify-evenly">
        <Form.Item label="کد ملی">
          <Input
            onChange={handleChange}
            style={{ width: size }}
            name="nationalCode"
            placeholder="کد ملی خود را وارد کنید"
            defaultValue={modalData?.nationalCode}
          />
        </Form.Item>
        <Form.Item label="وضعیت اشتغال">
          <Select
            onChange={(e) => {
              handelSelectChange("workplaceOrganizationTypeId", e);
              setWorkPlaceId(e);
            }}
            options={workPlaceOptions}
            style={{ width: size }}
            placeholder="انتخاب کنید"
            defaultValue={modalData?.workplaceOrganizationType?.name}
            showSearch={false}
          />
        </Form.Item>
      </div>
      <div className="flex flex-row max-lg:flex-col justify-evenly">
        <Form.Item label="نام محل کار">
          <Input
            onChange={handleChange}
            name="workplaceOrganizationName"
            style={{ width: size }}
            placeholder="نام محل کار را وارد کنید"
            defaultValue={modalData?.workplaceOrganizationName}
          />
        </Form.Item>
        <Form.Item label="سمت">
          {workPlaceId === 1 || workPlaceId === 2 || workPlaceId === 3 ? (
            <Select
              onChange={(e) =>
                handelSelectChange("workplaceOrganizationPositionId", e)
              }
              options={workPlacePositionOptions}
              style={{ width: size }}
              placeholder="انتخاب کنید"
              defaultValue={modalData?.workplaceOrganizationPosition?.name}
              showSearch={false}
            />
          ) : (
            <Input
              onChange={
                handleChange
              }
              name="workplaceOrganizationPositionName"
              style={{ width: size }}
              defaultValue={modalData?.workplaceOrganizationPositionName}
            />
          )}
        </Form.Item>
      </div>
    </Form>
  );
}

export default NameModal;
